module.exports = __webpack_public_path__ + "img/pre-order.svg";